



<div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
  
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
               
                <div class="col-12  featured-box">
                    <div class="hero-section">
                        <h1>Live Betting Reimagined 🚀</h1>
                        <p>India's Most Trusted Online Betting Platform</p>
                        <img src="/logo.png" alt="Livescorebet Logo" style="max-width: 200px; margin: 2rem auto;">
                    </div>
            
                    <div class="feature-card">
                        <h2>Why Choose Livescorebet.online?</h2>
                        <p>150,000+ Indian Players Trust Our Platform</p>
                    </div>
            
                    <div class="feature-card">
                        <h3>🏏 Live Cricket Betting</h3>
                        <ul>
                            <li>IPL, World Cup, CPL & More</li>
                            <li>Real-time Odds & Live Scores</li>
                            <li>In-play Betting Options</li>
                        </ul>
                    </div>
            
                    <div class="feature-card">
                        <h3>🎰 Ultimate Casino Experience</h3>
                        <ul>
                            <li>Live Dealer Tables</li>
                            <li>Andar Bahar & Teen Patti</li>
                            <li>1000+ Slot Games</li>
                        </ul>
                    </div>
            
                    <div class="feature-card">
                        <h3>⚡ Lightning-Fast Transactions</h3>
                        <ul>
                            <li>60-Second Withdrawals</li>
                            <li>UPI & Paytm Support</li>
                            <li>24/7 Transaction Monitoring</li>
                        </ul>
                    </div>
            
                    <div class="feature-card">
                        <h3>🔒 Military-Grade Security</h3>
                        <ul>
                            <li>256-bit SSL Encryption</li>
                            <li>PCI-DSS Certified Payments</li>
                            <li>Two-Factor Authentication</li>
                        </ul>
                    </div>
            
                    <div class="feature-card" style="text-align: center;">
                        <h2>Ready to Play? 🎉</h2>
                        <a href="/register" class="cta-button">Start Betting Now →</a>
                        <p>Get ₹1000 Welcome Bonus + Free Spins! 🎁</p>
                    </div>
            
                    <footer style="text-align: center; padding: 2rem 0;">
                        <p>🔞 21+ Only | 🏛️ Licensed & Regulated | 🇮🇳 Proudly Indian</p>
                        <p>Need Help? <a href="/contact" style="color: var(--primary-orange);">24/7 Support</a></p>
                    </footer>
                    </div>
                
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>

<app-footer-main></app-footer-main>

